import {saveUserDataToLocalStorage} from '@/services/localStorage-users-data';
import Vue from 'vue';

export default {
  appError(state: any, value: string) {
    state.appError = value;
    //state.appErrorStatus = AppErrorStatusEnum.initial;
  },
  panelBlocked(state: any, value: boolean) {
    state.panelBlocked = value;
  },
  // appErrorStatus(state: any, value: string) {
  //   state.appErrorStatus = value;
  // },
  loading(state: any, value: any) {
    state.isLoading = value;
  },
  getCurrencyList(state: any, list: any) {
    state.currencyList = list;
  },
  getCountryList(state: any, list: any) {
    state.countryList = list;
  },
  getTimezoneList(state: any, list: any) {
    state.timezoneList = list;
  }, 
  alertsCount(state: any, payload: number) {
    state.alertsCount = payload;
  },
  initBookmarks(state: any, bookmarks: Bemob.Bookmark[]) {
    state.bookmarks = bookmarks;
  },
  addBookmark(state: any, bookmark: Bemob.Bookmark) {
    state.bookmarks.push(bookmark);

    saveUserDataToLocalStorage(state.user.id,{bookmarks:state.bookmarks});
  },
  editBookmark(state: any, payload: any) {
    const bookmark = payload.bookmark as Bemob.Bookmark;
    const index = payload.index as number;
    
    Vue.set(state.bookmarks, index, bookmark);

    saveUserDataToLocalStorage(state.user.id,{bookmarks:state.bookmarks});
  },
  removeBookmark(state: any, index: number) {
    state.bookmarks.splice(index, 1);

    saveUserDataToLocalStorage(state.user.id,{bookmarks:state.bookmarks});
  },
};
